<div class="email-dashboard-container">
  <div class="email-dashboard-header">
    <div>
      <h1>Emails Gmail</h1>
      <p class="subtitle">Classification automatique depuis n8n</p>
    </div>

    <button
      pButton
      type="button"
      icon="pi pi-refresh"
      label="Actualiser"
      class="p-button-outlined"
      (click)="refresh()"
    ></button>
  </div>

  <div class="metrics-grid">
    <div class="metric-card metric-danger">
      <span class="metric-label">Mails avec pb</span>
      <strong>{{ problemCount }}</strong>
    </div>
    <div class="metric-card metric-warning">
      <span class="metric-label">En cours</span>
      <strong>{{ inProgressCount }}</strong>
    </div>
    <div class="metric-card metric-info">
      <span class="metric-label">Traites</span>
      <strong>{{ treatedCount }}</strong>
    </div>
    <div class="metric-card">
      <span class="metric-label">Ignores</span>
      <strong>{{ ignoredCount }}</strong>
    </div>
  </div>

  <div class="filters-bar" [class.admin]="isAdmin">
    <span class="p-input-icon-left search-field">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        [(ngModel)]="searchTerm"
        placeholder="Recherche email, origine, projet"
        (keyup.enter)="applyFilters()"
      />
    </span>

    <p-dropdown
      [options]="classificationOptions"
      [(ngModel)]="selectedClassification"
      optionLabel="label"
      optionValue="value"
      placeholder="Classification"
      appendTo="body"
      panelStyleClass="email-issues-filter-panel"
      [scrollHeight]="'320px'"
      (onChange)="applyFilters()"
    ></p-dropdown>

    <p-dropdown
      [options]="clientOptions"
      [(ngModel)]="selectedClientExists"
      optionLabel="label"
      optionValue="value"
      placeholder="Origine"
      appendTo="body"
      panelStyleClass="email-issues-filter-panel"
      [scrollHeight]="'320px'"
      (onChange)="applyFilters()"
    ></p-dropdown>

    <p-dropdown
      [options]="statusOptions"
      [(ngModel)]="selectedStatus"
      optionLabel="label"
      optionValue="value"
      placeholder="Statut"
      appendTo="body"
      panelStyleClass="email-issues-filter-panel"
      [scrollHeight]="'320px'"
      (onChange)="applyFilters()"
    ></p-dropdown>

    <p-dropdown
      *ngIf="isAdmin"
      [options]="userOptions"
      [(ngModel)]="selectedUserId"
      optionLabel="label"
      optionValue="value"
      placeholder="Utilisateur"
      appendTo="body"
      panelStyleClass="email-issues-filter-panel"
      [scrollHeight]="'320px'"
      (onChange)="applyFilters()"
    ></p-dropdown>

    <button
      pButton
      type="button"
      icon="pi pi-search"
      class="p-button-outlined icon-action"
      pTooltip="Appliquer les filtres"
      (click)="applyFilters()"
    ></button>
    <button
      pButton
      type="button"
      icon="pi pi-filter-slash"
      class="p-button-text icon-action"
      pTooltip="Vider les filtres"
      (click)="clearFilters()"
    ></button>
  </div>

  <div *ngIf="error" class="error-state">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ error }}</span>
  </div>

  <p-table
    [value]="issues"
    [loading]="loading"
    [paginator]="true"
    [rows]="rows"
    [first]="first"
    [totalRecords]="totalRecords"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    [rowsPerPageOptions]="[10, 25, 50, 100]"
    responsiveLayout="stack"
    breakpoint="1200px"
    styleClass="email-issues-table"
    [tableStyle]="{ width: '100%' }"
    (onLazyLoad)="onLazyLoad($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Date</th>
        <th>Expediteur</th>
        <th>Objet</th>
        <th>Contenu</th>
        <th>Pb detecte</th>
        <th>Origine</th>
        <th *ngIf="isAdmin">Utilisateur</th>
        <th>Statut</th>
        <th>Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-issue>
      <tr>
        <td class="date-cell">
          <span class="p-column-title">Date</span>
          {{ formatDate(issue.received_at || issue.created_at) }}
        </td>
        <td>
          <span class="p-column-title">Expediteur</span>
          <div class="sender-cell">
            <strong>{{ issue.from_name || issue.from_email }}</strong>
            <span *ngIf="issue.from_name">{{ issue.from_email }}</span>
          </div>
        </td>
        <td>
          <span class="p-column-title">Objet</span>
          <div class="subject-cell">
            <strong>{{ issue.subject || 'Sans objet' }}</strong>
          </div>
        </td>
        <td>
          <span class="p-column-title">Contenu</span>
          <div class="content-cell-wrapper">
            <div class="content-cell">
              {{ getContentPreview(issue) }}
            </div>
            <button
              *ngIf="(issue.body || issue.snippet)?.trim()"
              pButton
              type="button"
              icon="pi pi-window-maximize"
              [label]="isContentExpandable(issue) ? 'Voir le mail' : 'Ouvrir'"
              class="p-button-text p-button-sm content-view-btn"
              pTooltip="Afficher le contenu complet"
              (click)="openEmailContentDialog(issue)"
            ></button>
          </div>
        </td>
        <td>
          <span class="p-column-title">Pb detecte</span>
          <div class="problem-cell">
            <ng-container *ngIf="issue.problem_keywords?.length; else noProblemLabel">
              <span class="problem-chip" *ngFor="let keyword of issue.problem_keywords">
                {{ keyword }}
              </span>
            </ng-container>
            <ng-template #noProblemLabel>
              <span class="problem-chip muted-chip">A verifier</span>
            </ng-template>
          </div>
        </td>
        <td>
          <span class="p-column-title">Origine</span>
          <div class="client-cell">
            <p-tag
              [value]="getOriginLabel(issue)"
              [severity]="getOriginSeverity(issue)"
            ></p-tag>
            <button
              *ngIf="canOpenProject(issue)"
              pButton
              type="button"
              class="p-button-link project-link"
              [label]="issue.project_id"
              (click)="openProject(issue)"
            ></button>
            <span>{{ getOriginDetail(issue) }}</span>
          </div>
        </td>
        <td *ngIf="isAdmin">
          <span class="p-column-title">Utilisateur</span>
          <div class="owner-cell">
            <span>{{ getOwnerLabel(issue) }}</span>
          </div>
        </td>
        <td>
          <span class="p-column-title">Statut</span>
          <p-tag
            [value]="getStatusLabel(issue.status)"
            [severity]="getStatusSeverity(issue.status)"
          ></p-tag>
        </td>
        <td>
          <span class="p-column-title">Actions</span>
          <div class="row-actions">
            <button
              pButton
              type="button"
              icon="pi pi-play"
              class="p-button-text icon-action"
              pTooltip="Marquer en cours"
              (click)="markStatus(issue, 'en_cours')"
            ></button>
            <button
              pButton
              type="button"
              icon="pi pi-check"
              class="p-button-text icon-action success-action"
              pTooltip="Marquer traite"
              (click)="markStatus(issue, 'traite')"
            ></button>
            <button
              pButton
              type="button"
              icon="pi pi-ban"
              class="p-button-text icon-action muted-action"
              pTooltip="Ignorer"
              (click)="markStatus(issue, 'ignore')"
            ></button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="isAdmin ? 9 : 8">Aucun email trouve.</td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [(visible)]="showEmailContentDialog"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [style]="{ width: '720px', maxWidth: '95vw' }"
    styleClass="email-content-dialog"
    (onHide)="closeEmailContentDialog()"
  >
    <ng-template pTemplate="header" *ngIf="selectedEmailForView as email">
      <div class="email-content-dialog-header">
        <span class="email-content-dialog-title">{{ email.subject || 'Sans objet' }}</span>
        <span class="email-content-dialog-meta">{{ getSenderLabel(email) }}</span>
        <span class="email-content-dialog-meta">{{ formatDate(email.received_at || email.created_at) }}</span>
      </div>
    </ng-template>

    <div class="email-content-dialog-body" *ngIf="selectedEmailForView as email">
      <pre class="email-content-full">{{ getFullEmailContent(email) }}</pre>
    </div>

    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        label="Fermer"
        icon="pi pi-times"
        class="p-button-text"
        (click)="closeEmailContentDialog()"
      ></button>
    </ng-template>
  </p-dialog>
</div>
